import {
  FilterableSurveyResult,
  SecurityCultureSurvey,
} from '@/client/security-culture/types';
import { EmptyProductCard } from '@/components/dashboards/admin';
import {
  SCFeedback,
  SCOverTime,
  SCParticipation,
  SCScoreBars,
  SecurityCultureDemoScore,
  SecurityCultureScore,
} from '@/components/security-culture';
import { FlexContainer } from '@/ui/styled-ui';
import { ProductType } from '@/utils/helpers';
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  @media screen and (max-width: 1450px) {
    & {
      flex-wrap: wrap;

      > div {
        flex: none;
      }
    }
  }
`;

interface SCReportProps {
  surveyReports: FilterableSurveyResult | undefined;
  areSurveyReportsLoading: boolean;
  overTimeParsed: {
    values: number[];
    labels: string[];
  };
  selectedSurveys: SecurityCultureSurvey[] | undefined;
  isFilterApplied?: boolean;
  isDemo?: boolean;
}

export const SCReport: React.FC<SCReportProps> = ({
  surveyReports,
  areSurveyReportsLoading,
  overTimeParsed,
  selectedSurveys,
  isFilterApplied,
  isDemo,
}) => {
  if (!surveyReports || areSurveyReportsLoading || !selectedSurveys?.length) {
    return null;
  }

  if (surveyReports.participantsCount < 5) {
    return (
      <EmptyProductCard
        type={ProductType.SECURITY_CULTURE_DASHBOARD}
        id="empty-security-culture-dashboard"
      />
    );
  }

  return (
    <>
      <StyledContainer align="stretch" justify="space-between" gap={24}>
        {isDemo ? (
          <SecurityCultureDemoScore isSurveyPage />
        ) : (
          <SecurityCultureScore
            filterableSurvey={surveyReports}
            onlyOneSelectedSurvey={selectedSurveys?.length === 1}
          />
        )}
        <SCOverTime overTimeParsed={overTimeParsed} isDemo={isDemo} />
      </StyledContainer>

      <SCScoreBars
        filterableCategories={surveyReports?.categories}
        surveyId={selectedSurveys?.map((survey) => survey.id).join(',')}
        isLoading={areSurveyReportsLoading}
        isDemo={isDemo}
      />

      <StyledContainer gap={24} align="stretch">
        <SCParticipation filterableSurvey={surveyReports} isDemo={isDemo} />
        <SCFeedback
          feedback={surveyReports?.feedback}
          surveyId={selectedSurveys?.map((survey) => survey.id).join(',')}
          isFilterApplied={isFilterApplied}
          isDemo={isDemo}
        />
      </StyledContainer>
    </>
  );
};
